import IPage from "interfaces/page";
import SignUpForm from "features/signUp/SignUpForm";
import AuthHeader from "features/authHeader/AuthHeader";
import FullscreenContainer from "features/containers/FullscreenContainer";

const SignUp: React.FC<IPage> = () => {
  return (
    <FullscreenContainer sx={{ bgcolor: "primary.main" }}>
      <AuthHeader />
      <SignUpForm />
    </FullscreenContainer>
  );
};

export default SignUp;
